import script from "./EgovMobileSignModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EgovMobileSignModal.vue?vue&type=script&lang=ts&setup=true"

import "./EgovMobileSignModal.vue?vue&type=style&index=0&id=9c664a96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c664a96"]])

export default __exports__